'use strict';

var EmployeeBaseRouter = require('./Base');
var Layout             = require('../views/payslips/Layout');

import Payslip from 'newModels/payslip.js';
import Payslips from 'newCollections/payslips.js';
import Attachments from 'newCollections/attachments.js';
import moment from 'moment';
import LeaveRequests from 'newCollections/leave-requests.js';

module.exports = EmployeeBaseRouter.extend({
    routes: {
        'payslips': 'payslips',
        'view/:id': 'view'
    },

    titles: {
        'payslips': 'Payslips',
        'view':     'View',
        'view/:id': 'View'
    },

    // TODO it is a big and multiplied method, refactor it later
    fetchBalance: function(payslip) {
        const fetchYearlyBalances = () => {
            return app.leaveTypes.fetchBalances(
                payslip.getEmployee(),
                payslip.getPeriod().endOf('month').toDate()
            );
        };

        const transformYearly = leaveTypes => {
            return leaveTypes.map(leaveType => {
                const name = leaveType.get('name');
                const id = leaveType.id;
                const entitled = leaveType.getEntitled() || 0;
                const taken = leaveType.getTaken() || 0;
                const remaining = Math.max(0, entitled - taken);
                return {
                    id,
                    name,
                    entitled,
                    remaining,
                    taken
                };
            });
        };

        const mergeBalances = (yearly, monthly) => {
            const obligated = _.filter(yearly, balance => {
                return [
                    'Medical Leave',
                    'Annual Leave',
                    'Unpaid Leave',
                ].includes(balance.name);
            });
            const yearlyHasInMontly = _.filter(yearly, balance => (
                _.map(monthly, t => t.id)
                    .includes(balance.id) && balance.taken > 0
            ))
                .concat(obligated);

            const mergeBalances = _.map(yearlyHasInMontly, balance => {
                const sameMonthlyBalance = monthly
                    .find(t => t.id === balance.id);
                if (balance.taken > 0) {
                    const newTaken = sameMonthlyBalance ?
                        sameMonthlyBalance.taken : 0;
                    balance.taken = newTaken;
                }
                return balance;
            });
            return mergeBalances;
        };

        const fetchMonthlyBalance = (types, reference) => {
            const end = moment(reference).endOf('month').toDate();
            const start = moment(reference).startOf('month').toDate();
            return LeaveRequests.fetchForBalances({
                employee: payslip.getEmployee(),
                typeIds: types.map(t => t.id),
                start,
                end
            }).then((requests) => {
                const simplified = requests.map(request => {
                    const id = request.get('typeId');
                    const taken = request.get('daysRequired');
                    return {
                        id,
                        taken
                    };
                }) || [];
                const groupedById = _.groupBy(simplified, 'id');
                const summedById = _.map(groupedById, requests => {
                    const taken = _.reduce(requests,
                        (sum, request) => sum + request.taken, 0
                    );
                    return {
                        id: requests[0].id,
                        taken
                    };
                });

                return summedById;
            });
        };

        return fetchYearlyBalances()
            .then(yearlyBalances => Promise.all([
                transformYearly(yearlyBalances),
                fetchMonthlyBalance(
                    yearlyBalances,
                    payslip.getPeriod().toDate()
                )
            ]))
            .then(([yearly, monthly]) => mergeBalances(yearly, monthly));
    },

    payslips: function() {
        this.undelegateEvents();
        this.layout = new Layout({
            el: this.el
        });

        const payslips = new Payslips(null, {
            employee: app.employee,
            pagination: {rowsPerPage: 20},
            sortKey: 'createdAt',
            sortOrder: 'descending',
            validate: false
        });
        return payslips.fetch(
            {filter: {where: {status: 'done'}}}
        ).then(() => {
            return Promise.all(payslips.map(payslip => {
                const attachments = new Attachments(null, {
                    attachable: payslip,
                });
                return payslip.fetch().then(() => {
                    return attachments.fetch({
                        filter: {
                            order: 'createdAt DESC',
                        }
                    });
                }).then(() => {
                    return [
                        payslip.id,
                        attachments
                    ];
                });
            }));
        }).then(attchMap => {
            return Promise.resolve(_.object(attchMap));
        }).then(attachments => {
            this.layout.renderPayslips({
                payslips:    payslips,
                attachments: attachments
            });
        });
    },

    view: function(id) { // .. in progress ..
        this.undelegateEvents();

        this.layout = new Layout({
            el: this.el
        });

        return Promise.all([
            new Payslip({objectId: id})
                .fetch({validate: false}),
            app.company.fetchPrimaryLocation()
        ]).then(([payslip, companyLocation]) => {
            payslip.employee = app.employee;
            return Promise.all([
                payslip,
                payslip.fetchDetails(),
                companyLocation,
                this.fetchBalance(payslip),
                companyLocation.fetchAddress()
            ]);
        }).then(([payslip, payslipDetails, companyLocation, balances]) => {
            payslipDetails.balances = balances;
            this.layout.renderView({
                payslip: payslip,
                payslipDetails: payslipDetails,
                companyLocation: companyLocation,
                company: app.company
            });
        });
    }
});



// WEBPACK FOOTER //
// ./app/employee/routers/Payslips.js